import React from 'react';
import './experience.css'
import {BsPatchCheckFill} from 'react-icons/bs'
const Experience = () => {
  return (
  <section id='experience'>
    <h5>What Skills I Have</h5>
    <h2>My Experience</h2>
    <div className="container experience__container">
      <div className="experience__frontend">
        <h3>Frontend Development</h3>
        <div className="experience__content">
          <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
             <div>
             <h4>HTML</h4>
            <small className='text-light'>Experienced</small> 
             </div>
            </article>
            <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
             <div>
             <h4>CSS & Tailwind CSS</h4>
            <small className='text-light'>Experienced</small>
             </div>
            </article>
            <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
             <div>
             <h4>JavaScript ES6 & ES7</h4>
            <small className='text-light'>Experienced</small>
             </div>
            </article>
            <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
             <div>
             <h4>Typescript</h4>
            <small className='text-light'>Experienced</small>
             </div>
            </article>
            <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
             <div>
             <h4>React Js</h4>
            <small className='text-light'>Experienced</small>
             </div>
            </article>
            <article className='experience__details'>
                <BsPatchCheckFill className='experience__details-icon' />
             <div>
             <h4>API's</h4>
            <small className='text-light'>Experienced</small>
             </div>
            </article> 
            <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
             <div>
             <h4>Next Js</h4>
            <small className='text-light'>Intermediate</small>
             </div>
            </article>
            <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
             <div>
             <h4>Android development</h4>
            <small className='text-light'>Intermediate</small>
             </div> 
          

            </article>
          </div>

        </div>
        <div className="experience__backend">
        <h3>Backend Development</h3>
        <div className="experience__content">
          <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
             <div>
             <h4>NODE JS</h4>
            <small className='text-light'>Experienced</small>
             </div>
            </article>
            <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
             <div>
             <h4>MongoDB</h4>
            <small className='text-light'>Experienced</small>
             </div>
            </article>
            <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
             <div>
             <h4>Firebase</h4>
            <small className='text-light'>Experienced</small>
             </div>
            </article>
            <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
             <div>
             <h4>Python</h4>
            <small className='text-light'>Intermediate</small>
             </div>
            </article>
            <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
             <div>
             <h4>Sanity</h4>
            <small className='text-light'>Experienced</small>
             </div>
            </article>
            <article className='experience__details'>
            <BsPatchCheckFill className='experience__details-icon' />
             <div>
             <h4>Networking & Routing</h4>
            <small className='text-light'>Experienced</small>
             </div>
            </article>
      
          </div>

          </div>
      </div>
  </section>
  )
};

export default Experience;
